import { render, staticRenderFns } from "./NotificacoesOperacaoHost.vue?vue&type=template&id=3d1698c4&"
import script from "./NotificacoesOperacaoHost.vue?vue&type=script&lang=js&"
export * from "./NotificacoesOperacaoHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports